<div class="check-grid check-grid--row">
  <!-- Post number -->
  <div class="check-grid__post">
    {{ documentNode.ordinal != null ? documentNode.ordinal + 1 : '' }}
  </div>

  <!-- Name / description -->
  <div class="check-grid__name">
    @if (editMode) {
      <input class="check-test-input" [(ngModel)]="data.name" (focus)="onFocus()" (blur)="onBlur()" placeholder="Description" />
    } @else {
      <span>{{ data.name }}</span>
    }
  </div>

  <!-- Executor company -->
  <div class="check-grid__executor">
    @if (editMode) {
      <mat-select
        class="check-test-select"
        [value]="data.executorCompany?.id"
        (selectionChange)="onCompanySelected($event.value)"
        placeholder="Company"
      >
        @for (company of (companies$ | async) || []; track company.id) {
          <mat-option [value]="company">{{ company.name }}</mat-option>
        }
      </mat-select>
    } @else {
      <span>{{ data.executorCompany?.name || '' }}</span>
    }
  </div>

  <!-- Sign -->
  <div class="check-grid__sign">
    @if (data.sign?.user) {
      <span class="signed">{{ data.sign.user.name }}</span>
    } @else {
      <span class="unsigned">&mdash;</span>
    }
  </div>

  <!-- Date -->
  <div class="check-grid__date">
    @if (data.sign?.timestamp) {
      <span>{{ data.sign.timestamp | date: 'shortDate' }}</span>
    }
  </div>

  <!-- Comments -->
  <div class="check-grid__comments">
    @if (editMode) {
      <input class="check-test-input" [(ngModel)]="data.comments" (focus)="onFocus()" (blur)="onBlur()" placeholder="Bemerkninger" />
    } @else {
      <span>{{ data.comments }}</span>
    }
  </div>
</div>
